import React, { useState, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useDispatch } from 'react-redux';

import { notification, Modal } from 'antd';
import { UploadFile } from 'common/components';
import { toggleReloadGrid } from 'pages/product-apl-detail/controllers/actions';

import * as aplEndpoints from 'services/apl/endpoints';
import ErrorModal from 'common/components/product-publication-setup/ErrorModal.js';

import { UPLOAD_MAX_SIZE } from 'static/Constants';
import { MASTER_APL_NAME } from 'pages/home/ribbon/components/sections/product-apl/constants';
import APLConfirmUpdatePopup from 'pages/home/ribbon/components/sections/product-apl/components/APLConfirmUpdatePopup';

import { getAplDetail } from 'pages/product-apl-detail/controllers/actions';
import {
  toggleReloadGridApl,
  resetReloadGridApl,
} from 'pages/branded-products-apl/controllers/actions';

const UploadTemplateAPLModal = (props) => {
  const { visibleModal, turnOffModal, aplId, aplDetail } = props;

  const [warningMissingAPLProductModal, setWarningMissingAPLProductModal] =
    useState(false);
  const [missingData, setMissingData] = useState([]);
  const [errorList, setErrorList] = useState([]);
  const [fileUpload, setFileUpload] = useState();
  const isMasterApl = aplDetail?.aplName === MASTER_APL_NAME;

  const queryClient = useQueryClient();

  const confirmMessage = isMasterApl
    ? 'This will replace the existing APL with a new Master List. Are you sure you’d like to continue?'
    : null;

  const dispatch = useDispatch();

  useEffect(() => {
    if (visibleModal) setErrorList([]);
  }, [visibleModal]);

  const handleResponseUpload = (response) => {
    if (response?.data) {
      if (response?.data?.isSuccess) {
        const hasDiffsData = response?.data?.data?.diffs?.length > 0;
        if (hasDiffsData) {
          setWarningMissingAPLProductModal(true);
          setMissingData(response?.data?.data);
        } else {
          queryClient.invalidateQueries({
            queryKey: ['apl'],
          });

          dispatch(getAplDetail({ aplId }));

          dispatch(toggleReloadGrid(true));
          setTimeout(() => {
            dispatch(toggleReloadGrid(false));
          }, 100);

          dispatch(toggleReloadGridApl());
          setTimeout(() => {
            dispatch(resetReloadGridApl());
          }, 200);

          notification.success({
            message: response?.data?.message,
          });
        }

        turnOffModal();
      } else {
        if (response?.data?.errors) {
          setErrorList(response?.data?.errors);
        }
      }
    }
  };

  const getFileChange = (paramsUpload) => {
    setFileUpload(paramsUpload.file.originFileObj);
  };

  return (
    <>
      <Modal
        width={'50vw'}
        bodyStyle={{ height: '50vh' }}
        title='Upload Template Product'
        visible={visibleModal}
        onCancel={turnOffModal}
        closable={true}
        maskClosable={false}
        footer={null}
        destroyOnClose
        centered
      >
        <div className='action-product__modal'>
          <UploadFile
            uploadAPL={true}
            manualUpload={true}
            isBase64={false}
            showMultiple={false}
            showXlsTemplate={false}
            apiUrl={aplEndpoints.UPLOAD_APL_PRODUCT_LIST}
            additionalBodyPayload={{
              AplId: aplId,
              AplUpdateOption: isMasterApl ? 'GetDiff' : '',
            }}
            nameFormData='TemplateFile'
            showUploadSuccessMsg={false}
            showServerMessage={true}
            getResponse={(response) => handleResponseUpload(response)}
            maxSize={UPLOAD_MAX_SIZE.GENERAL}
            supportTypes={['xlsx', 'xls']}
            getFileChange={getFileChange}
            confirmMessage={confirmMessage}
          />
          <div className='action-product__modal--error-text'>
            {errorList && errorList.length > 0 && (
              <ErrorModal
                errorList={errorList}
                isApl={true}
                title={'APL Errors'}
              />
            )}
          </div>
        </div>
      </Modal>
      {warningMissingAPLProductModal && (
        <APLConfirmUpdatePopup
          aplId={aplId}
          visible={warningMissingAPLProductModal}
          setWarningMissingAPLProductModal={setWarningMissingAPLProductModal}
          missingData={missingData}
          fileUpload={fileUpload}
        />
      )}
    </>
  );
};

export default UploadTemplateAPLModal;
